import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Antd from "ant-design-vue/";
import { message } from 'ant-design-vue';
import "ant-design-vue/dist/antd.css";
import dataV from '@jiaminghi/data-view'
// import SocketIO from './utils/io'

import "./assets/svgIcon/index";
import svgIcon from "./assets/svgIcon/index.vue";

import "./assets/css/common.css";
// import "./permission"
const app = createApp();
app.config.productionTip = false;
app.config.globalProperties.$message = message;

message.config({
  duration: 2,// 持续时间
  top:`100px`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

createApp(App, Antd)
  .use(store)
  .use(router)
  .use(Antd)
  .use(dataV)
  .component("svg-icon", svgIcon)
  // .use(SocketIO, {
  //   debug: true,
  //   connection: '',
  // })
  .mount("#app");
